import {ThemeType} from "../../shared";

export default function Court2({}) {
    return (
        <svg width="55" height="67" viewBox="0 0 55 67" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="27.5655" cy="33.4177" r="26.7341" transform="rotate(-90 27.5655 33.4177)" stroke="currentColor" strokeWidth="1.11392"/>
            <line x1="27.0085" y1="66.835" x2="27.0085" y2="-0.000350928" stroke="currentColor" strokeWidth="1.11392"/>
        </svg>
    );
}